import { sha256 } from 'js-sha256'
import { Optional } from '../index'
import { getPersistedId } from 'services/Authentication/Utils/PersistedData'

/**
 * Performs the way overkill SHA256 function against the passed string
 * @param message
 */
const hashStringSHA256 = (message: string): string => {
	const encoder = new TextEncoder()
	const data = encoder.encode(message)
	return sha256(data)
}

/**
 * Returns a value between 0 and 1 representing the percentile of the hash
 * @param hash
 */
const hashPercentile = (hash: string) => {
	const num = parseInt(hash, 16)
	const maxHashValue = Math.pow(2, 256)
	return num / maxHashValue
}

/**
 * Returns a deterministic and consistent percentile (value between 0 and 1) to be used for experiments
 */
export const getUserBucket = (): Optional<number> => {
	const id = getPersistedId()
	if (!id) return undefined
	const hash = hashStringSHA256(id)
	return hashPercentile(hash)
}
